var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { Box, LoadingBox, translate } from '@lucidlink/uicore';
import { useUserWorkspaces } from '#query-hooks';
export const WorkspaceStatusRouteGuard = ({ children, predicateFn, }) => {
    _react_refresh_temp_2();
    const location = useLocation();
    const { workspaceId = '' } = useParams();
    const { query: { data: userWorkspaces, isLoading: isLoadingUserWorkspaces }, } = useUserWorkspaces();
    const workspaceData = userWorkspaces?.find((ws) => ws.id === workspaceId);
    const result = predicateFn({
        workspaceId: workspaceId,
        workspaceStatus: workspaceData?.status,
    });
    if (isLoadingUserWorkspaces) {
        return (_jsx(Box, { align: "center", isFullHeight: true, isFullWidth: true, justify: "center", children: _jsx(LoadingBox, { alt: translate('checking workspace status'), "data-testid": "checking-ws-status", isFullHeight: true }) }));
    }
    if (result.isSuccess) {
        return children;
    }
    return _jsx(Navigate, { to: result.navigateTo }, location.key);
};
_react_refresh_temp_1 = WorkspaceStatusRouteGuard;
$RefreshReg$(_react_refresh_temp_1, "WorkspaceStatusRouteGuard");
_react_refresh_temp_2(WorkspaceStatusRouteGuard, "TCOYpXtsjdnLtTblu3/vvdXCZ6o=", false, () => [useLocation, useParams, useUserWorkspaces]);
